import { Moon, Sun, Search, ChevronRight, Home } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { Button } from '@/components/ui/button';
import { useLessonStore } from '@/store/lessonStore';
import { getModuleAndLessonByLessonId } from '@/data/index';
import { Link, useLocation } from 'react-router-dom';

/**
 * Header компонент с динамической breadcrumb навигацией и настройками
 */
export function Header() {
  const { theme, setTheme } = useTheme();
  const { progress } = useLessonStore();
  const location = useLocation();

  // Определяем текущий урок из URL или из store
  const getCurrentLessonId = (): string | null => {
    // Проверяем URL для страницы урока
    const lessonMatch = location.pathname.match(/^\/lesson\/(.+)$/);
    if (lessonMatch && lessonMatch[1]) {
      return lessonMatch[1];
    }
    // Если на главной странице, не показываем хлебные крошки урока
    if (location.pathname === '/') {
      return null;
    }
    // Иначе используем текущий урок из store
    return progress.currentLessonId ?? null;
  };

  const currentLessonId = getCurrentLessonId();
  const currentData = currentLessonId ? getModuleAndLessonByLessonId(currentLessonId) : null;

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <header className="flex h-14 items-center justify-between border-b bg-background px-6">
      {/* Breadcrumb навигация */}
      <nav className="flex items-center gap-1 text-sm">
        {/* Git Lessons - ссылка на главную */}
        <Link
          to="/"
          className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors duration-200"
        >
          <Home className="h-3.5 w-3.5" />
          <span>Git Lessons</span>
        </Link>

        {/* Если есть текущий урок, показываем модуль и урок */}
        {currentData && currentData.module && currentData.lesson && (
          <>
            <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
            <Link
              to={`/lesson/${currentData.module.lessons[0]?.id ?? ''}`}
              className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              {currentData.module.title}
            </Link>

            <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
            <span className="font-medium text-primary">{currentData.lesson.title}</span>
          </>
        )}
      </nav>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {/* Search */}
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Search className="h-4 w-4" />
          <span className="sr-only">Поиск</span>
        </Button>

        {/* Theme toggle */}
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={toggleTheme}>
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          <span className="sr-only">Переключить тему</span>
        </Button>
      </div>
    </header>
  );
}
